import 'babel-polyfill';
import 'vue2-animate/dist/vue2-animate.min.css';
import directive from './common/directive/directive';

import Vue from 'vue';
import App from './App.vue';

import vuetify from './plugin/vuetify';
import router from './router';
import i18n from './translations';
import store from './store';
import './common/fonts/iconfont/iconfont';

import 'swiper/dist/css/swiper.css';
import 'viewerjs/dist/viewer.css';

import VueAwesomeSwiper from 'vue-awesome-swiper';
import VueSocketIO from 'vue-socket.io';
import tool from './common/js/tool';
import VueCountryIntl from 'vue-country-intl';
import 'vue-country-intl/lib/vue-country-intl.css';
import VueTelInput from './components/vue-tel-input';
import Viewer from 'v-viewer';
import VueClipboard from 'vue-clipboard2';

import commonMixin from './common/mixin/common';
import VueSocketWrapper from './plugin/ws/index';
import VTooltip from 'v-tooltip';

var SocialSharing = require('vue-social-sharing');

Vue.use(SocialSharing);

import { ValidationObserver, ValidationProvider } from 'vee-validate';

//import IconFont from 'vue-iconfonts'
import './common/fonts/iconfont/iconfont.css'
import './common/fonts/iconfont/iconfont.js'

import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader

//Vue.component('IconFont', IconFont)

require('es6-promise').polyfill();
require('es6-promise/auto');

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
Vue.component(VueCountryIntl.name, VueCountryIntl);

Vue.use(VueAwesomeSwiper);
Vue.use(Viewer);
Vue.use(VueTelInput);
Vue.use(VueClipboard);
Vue.use(VTooltip);

Vue.use(VueSocketWrapper, {
  url: window.env.tradeSocket.url,
  path: window.env.tradeSocket.path,
});

Vue.mixin(commonMixin);

Vue.prototype.arrayConvertToObject = tool.arrayConvertToObject;

Vue.config.productionTip = false;


new Vue({
  vuetify,
  router,
  i18n,
  store,
  icons: {
    iconfont: 'md',
  },
  render: h => h(App)
}).$mount('#app');
